import { t } from 'i18next';
import { LitElement, PropertyValueMap, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { ColorVersionStepDto, SelectModeEnum, StepEnum } from '@/api-sdk';
import { isScrolledIntoView, scrollStepIntoView } from '@/utils';

import '../fg-configurator-step';
import './color-version/fg-color-option';
import './color-version/fg-version-option';
import './color-version/fg-version-options-list';

@customElement('fg-configurator-step-color-version')
export class FgConfiguratorStepColorVersion extends LitElement {
  @property({ type: Array })
  colorOptions: ColorVersionStepDto['colors'] = [];

  @property({ type: Array })
  versionOptions: ColorVersionStepDto['versions'] = [];

  @property({ type: String })
  selectMode: SelectModeEnum = SelectModeEnum.single;

  @property({ type: String })
  selectModeSwitchQueryString: ColorVersionStepDto['selectModeSwitchQueryString'] =
    '';

  @property({ type: Boolean })
  scrollToStep = false;

  @property({ type: String })
  stepType?: StepEnum;

  render() {
    return html`
      <fg-configurator-step-color
        .stepType=${this.stepType}
        .stepTitle=${t('headers.chooseColor') || ''}
        .colorOptions=${this.colorOptions}
        .selectMode=${this.selectMode}
        .selectModeSwitchQueryString=${this.selectModeSwitchQueryString}
      ></fg-configurator-step-color>

      <fg-version-options-list
        .stepTitle="${t('headers.chooseVersion') || ''}"
        .options=${this.versionOptions}
      ></fg-version-options-list>
    `;
  }

  protected willUpdate(
    _changedProperties: PropertyValueMap<any> | Map<PropertyKey, unknown>,
  ): void {
    if (_changedProperties.has('scrollToStep') && this.scrollToStep) {
      scrollStepIntoView(this);

      isScrolledIntoView(this);
    }
  }

  static styles = css`
    fg-configurator-step-color {
      scroll-margin-top: 100px;
    }
    fg-version-options-list {
      display: block;
      margin-top: 20px;
    }
  `;
}
